function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#0B8888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.333
}, React.createElement("path", {
  d: "M54.833 4.364C54.833 3.058 53.79 2 52.5 2h-49C2.211 2 1.167 3.058 1.167 4.364v47.272C1.167 52.942 2.21 54 3.5 54h49c1.289 0 2.333-1.058 2.333-2.364V4.364z"
}), React.createElement("path", {
  d: "M47.833 20.91c0 .652-.522 1.18-1.166 1.18H9.333c-.644 0-1.166-.528-1.166-1.18V10.272c0-.653.522-1.182 1.166-1.182h37.334c.644 0 1.166.529 1.166 1.182v10.636zM8.167 29.182H24.5M8.167 36.273H24.5M8.167 43.364H24.5M31.5 29.182h16.333M31.5 36.273h16.333M31.5 43.364h16.333"
}));

var SvgNewsPaper = function SvgNewsPaper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNewsPaper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/news-paper.ce9373b1.svg";
export { ForwardRef as ReactComponent };